export default "__VITE_ASSET__DX05wJwu__"